module.exports = __webpack_public_path__ + "static/media/credit-icon-active.b2690271.png";